// NPM Imports
// Quote Context
// Component Imports
// JS Imports
// Asset Imports

export default function Spacer({ extraClassNames = '' }) {
   let className = 'row-spacer-bhr1 ' + extraClassNames
   return <div className={className}>&nbsp;</div>
}
